export const skills=[
    {
        skills:"Problem sloving",
    },
    {
        skills:"Javascript",
    },
    {
        skills:"Figma",
    },
    {
        skills:"React Js",
    },
    {
        skills:"PHP & MySql",
    },
    {
        skills:"Node Js",
    },
    {
        skills:"python",
    },
    {
        skills:"Robotics",
    },
];